import * as THREE from 'three';
import TriangleMesh from '../representation3d/TriangleMesh';

export default class TriangleMeshGeometry {
    static create(triangleMesh: TriangleMesh, material: THREE.Material, layer: number): THREE.Mesh {
        const { vertices, indices, normals } = triangleMesh;

        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        if (indices) geometry.setIndex(new THREE.BufferAttribute(indices, 1));
        geometry.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
        geometry.computeVertexNormals(); 

        material.side = THREE.DoubleSide; // Temporary fix for invalid triangle normals
        const mesh = new THREE.Mesh(geometry, material);
        mesh.layers.set(layer);
        mesh.name = "TriangleMesh";
        
        return mesh;
    }
}
